import { useEffect, useMemo, useState } from 'react';
import { withNamespaces } from 'react-i18next';

import TableFilter from 'src/components/TableFilter';
import DateUtils from 'src/services/utils/DateUtils';
import { FreightStatuses } from '../constants';

const FilteringComponent = ({
    t,
    onChange,
}) => {
    const [tableFilters, setTableFilters] = useState({
        status: null,
        createdFrom: null,
        createdTo: null,
        search: null,
    });

    const dateUtils = new DateUtils();

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'status',
                title: 'Status',
                icon: <i className="ri-toggle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.status,
                data: Object.values(FreightStatuses).map((status) => ({
                    id: status.title,
                    title: status.title,
                })),
                formatter: (item) => t(item.title),
            },
            {
                type: 'date',
                name: 'filter-date',
                title: 'Date Range',
                icon: <i className="ri-calendar-event-line" />,
                defaultValue: {
                    from: tableFilters?.createdFrom,
                    to: tableFilters?.createdTo,
                },
            },
            {
                type: 'search_textbox',
                name: 'search',
                title: 'Search freights',
                icon: <i className="ri-search-2-line" />,
                defaultValue: tableFilters?.search,
                options: {
                    placeholder: 'Search by freight ID, route or cargo type',
                    typingDelay: 750,
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    setTableFilters((currentState) => ({
                        ...currentState,
                        search: value,
                    }));
                },
            },
        ];
    }, [
        tableFilters,
        t,
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {};

            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined;
            }

            if ('filter-date' in filters) {
                result.createdFrom = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.from),
                    'YYYY-MM-DD'
                );

                result.createdTo = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.to),
                    'YYYY-MM-DD'
                );
            }

            setTableFilters((currentState) => ({
                ...currentState,
                ...result,
            }));
        } else {
            setTableFilters({
                status: null,
                createdFrom: null,
                createdTo: null,
                search: independentTabsData?.search,
            });
        }
    };

    useEffect(() => {
        onChange && onChange(tableFilters);
    }, [
        onChange,
        tableFilters,
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab="status"
            tabs={tableFilterTabs}
            onOkButtonClicked={onTableFilterOkButtonClicked}
        />
    );
};

export default withNamespaces()(
    FilteringComponent
);
